<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <slot name="body">
                            <div class="d-flex justify-content-center">
                                <star-rating v-model="rateValue" :show-rating="false" :read-only="readOnly" :rounded-corners="true" :star-size="40" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"></star-rating>
                            </div>
                            <span class="mt-3 d-block text-center" v-if="rateValue!=null">امتیاز {{rateValue}} از ۵</span>
                            <span v-if="errorMsg!=null" class="mt-3 d-block text-center line-height-m"><i class="fa fa-exclamation-triangle ml-2 color-yellow1-light"></i> {{errorMsg}}</span>
                            <span v-if="Loading">در حال ارسال اطلاعات...</span>
                        </slot>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button v-if="readOnly==false" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveRate">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>
    import StarRating from 'vue-star-rating'

    export default {
        components: {
            StarRating
        },
        props: ['taskId', 'taskFolderId'],
        data() {
            return {
                rateValue: null,
                rateItem: {
                    rate: null,
                    taskId:null
                },
                Loading: false,
                errorMsg: null,
                readOnly:false
            };
        },
      
        mounted() {
            this.getRate();
            this.canAddRate();
        },
        methods: {
            getRate() {
                this.$http.get("Task/GetRateByTaskId?id=" + this.taskId)
                   .then(data => {
                        this.rateItem = data.data;
                        this.rateValue = data.data.rate;
                    });
            },
            canAddRate() {
                this.$http.get("Task/CanAddRate?taskId=" + this.taskId)
                    .then(data => {
                        if (data.data != "1") {
                            this.errorMsg = data.data;
                            this.readOnly = true;
                        }
                       
                    });
            },
            SaveRate() {
                if (this.rateValue == null) {
                    this.errorMsg="لطفا مقدار امتیاز را وارد کنید.";
                    return;
                }
                this.rateItem.rate = this.rateValue;
                this.rateItem.taskId = this.taskId;
                this.Loading = true;
                this.$http.post('task/RateSend', this.rateItem).then(response => {
                    if (response.status == 400 || response.data.success == false) {
                        var res = response.data.errors.map(a => a.errorMessage);
                        this.errorMsg =res;
                    }
                    else {
                        this.$emit('close');
                        this.showSuccessMessage("با موفقیت ثبت شد.");

                    }
                    this.Loading = false;
                }, error => {
                    this.showErrorMessage("خطا در ارسال اطلاعات");
                    this.Loading = false;
                    console.log(error);
                });
            }
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 1;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
